import Image from "next/image";
import LocationSVG from "/public/icons/location.svg";
import CalendarSVG from "/public/icons/calendar.svg";
import TimeSVG from "/public/icons/time.svg";

import { getTranslation } from "@/i18n/get-translation";
import moment from "moment";
import { IDoctorInfo, IReason } from "@/types/agenda.type";
import MOMENTJS_DATE_FORMATES from "@/common/constants/momentjs-format";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

interface IDoctorAppointmentHeader {
  locale: string;
  selectedDateTime?: string;
  setAppStep: any;
  doctorInfo?: IDoctorInfo;
  selectedReason?: IReason;
  appStep: number;
}

export default function DoctorAppointmentHeader({
  locale,
  doctorInfo,
}: IDoctorAppointmentHeader) {
  const t = getTranslation(locale, "appointment");
  const [profileImage, setProfileImage] = useState<string>("/images/doctor-male-avatar.webp");

  const doctorAddress: string[] | undefined = doctorInfo?.address?.split(";");
  const doctorDesignation: string[] | undefined =
    doctorInfo?.speciality?.split(";");

  useEffect(() => {
    if (doctorInfo?.media?.url) {
      setProfileImage(doctorInfo?.media?.url);
    } else {
      const placeholderImage =
        doctorInfo?.gender === "male"
          ? "/images/doctor-male-avatar.webp"
          : "/images/doctor-female-avatar.webp";
      setProfileImage(placeholderImage);
    }
  }, [doctorInfo]);

  return (
    <div className="pb-3 lg:pb-6 pt-[4.688rem] lg:pt-28 border-b border-b-gray-200 shadow-[0_0_1.0625rem_rgba(0,4,254,0.1)]">
      <div className="max-w-[1630px] mx-auto">
        <div className="px-4 lg:px-20">
          <div className="w-full flex items-center">
            <figure className="bg-white bg-gradient-to-t from-[#e5f5ff] to-white rounded-full w-[5.625rem] h-[5.625rem] lg:w-[9.375rem] lg:h-[9.375rem] border border-gray-200 mb-1 overflow-hidden mr-2 lg:mr-8 flex-none">
              <Image
                priority={true}
                width={150}
                height={150}
                src={profileImage}
                alt=""
                className="w-full h-full object-cover"
              />
            </figure>
            <div className="">
              <h1 className="text-agenda-purple-800 text-xl lg:text-3xl font-bold mb-1 lg:mb-2">
                {doctorInfo?.name}
              </h1>
              <h2 className="text-agenda-blue-600 text-md lg:text-xl">
                {doctorDesignation &&
                  doctorDesignation.map((designationItem: string, index: number) => {
                    return <div key={`designation_${index}`}>{designationItem}</div>;
                  })}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
